import {React, Component} from 'react'

class Home extends Component {
  render() {
    return (
      <div className='home-container'>
        <div className="home-content">
          <h2>HomePage</h2>
          <h2>HomePage</h2>
        </div>
      </div>
    );
  }
}

export default Home;